
import { Modal } from "../components/Modal";

export class ConfirmModal extends Modal {
    init() {
        super.init()
        this.confirmBtn.on('click', this.onConfirm.bind(this));
    }

    show(confirmCallback, title = null, text = null) {
        this.confirmCallback = confirmCallback;

        if (title) {
            this.title = title;
        }

        if (text) {
            this.text = text;
        }

        super.show();
    }

    onConfirm() {
        this.confirmCallback();
    }
}




